import React from "react";
import { Dialog, KeyValueList, LongTextLabel } from "@sscs/ui";
import { SharedReportForm } from "../../../../../types";
import getReportSettingsList from "../../ReportSettings/reportSettingsList";

type ReviewStepProps = {
  formData: SharedReportForm;
  resentToEmailAddressesCount: number;
  sentToEmailAddressesCount: number;
};

const ReviewStep = ({
  formData,
  resentToEmailAddressesCount,
  sentToEmailAddressesCount,
}: ReviewStepProps): React.JSX.Element => {
  return (
    <Dialog.Section>
      <Dialog.Section.Title>
        <span data-testid="report-link-name">
          <LongTextLabel label={formData.label} maxCharacters={60} inline />
        </span>
      </Dialog.Section.Title>
      <Dialog.Section.Description>
        Portal users can stop sharing the report at any time, which invalidates
        the existing link. To share the report again after it&apos;s unshared or
        expired, a new link must be generated.
      </Dialog.Section.Description>
      <Dialog.Section.Content>
        <KeyValueList
          list={getReportSettingsList({
            expiresIn: formData.expires_in,
            sharedReportOptions: formData,
            resentToEmailAddressesCount,
            sentToEmailAddressesCount,
          })}
        />
      </Dialog.Section.Content>
    </Dialog.Section>
  );
};

export default ReviewStep;
